import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { RotateCcw } from 'lucide-react';
import { IJobOpeningsAppliedFilters } from '../interfaces';

export interface JobOpeningsAppliedFiltersProps {
  appliedFilters: IJobOpeningsAppliedFilters;
  onRemoveFilter: (label: string, value: string | null) => void;
  onClearFilters: () => void;
}

export const JobOpeningsAppliedFilters = ({
  appliedFilters,
  onRemoveFilter,
  onClearFilters,
}: JobOpeningsAppliedFiltersProps) => {
  const filterEntries = Object.entries(appliedFilters);
  if (filterEntries.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
        p: 1.5,
        mb: 2,
        borderRadius: 2,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', mr: 0.5 }}>
        Filters:
      </Typography>

      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ alignItems: 'center' }}>
        {filterEntries.map(([label, values]) =>
          values.map((val, idx) => (
            <Chip
              key={`${label}-${idx}`}
              label={`${label}: ${val}`}
              size="small"
              onDelete={() => onRemoveFilter(label, val)}
              sx={{
                bgcolor: 'grey.100',
                color: 'text.primary',
                fontSize: '0.75rem',
                fontWeight: 500,
                borderColor: 'grey.300',
                '& .MuiChip-deleteIcon': {
                  color: 'text.secondary',
                  '&:hover': {
                    color: 'error.main',
                  },
                },
              }}
            />
          )),
        )}

        <Button
          size="small"
          onClick={onClearFilters}
          startIcon={<RotateCcw size={12} />}
          sx={{
            textTransform: 'none',
            fontSize: '0.75rem',
            color: 'text.secondary',
            py: 0.25,
            px: 1,
            minHeight: 'unset',
            '&:hover': {
              color: 'error.main',
              bgcolor: 'transparent',
            },
          }}
        >
          Clear all
        </Button>
      </Stack>
    </Box>
  );
};
